import React, { useEffect, useState } from 'react';
import axios from 'axios';

const WhyUs = () => {
  const [whyUsData, setWhyUsData] = useState([]);
  const apiUrl = import.meta.env.VITE_API_URL;

  useEffect(() => {
    axios.get(`${apiUrl}/home/why-us`)
      .then(response => setWhyUsData(response.data))
      .catch(error => console.error("Error fetching Why Us data:", error));
  }, []);



  const { title, subtitle, bgColor, textColor, features } = whyUsData;

  return (
    <section
      className="relative py-12 sm:py-16 lg:py-24 px-6"
      style={{ backgroundColor: bgColor, color: textColor }}
    >
      {/* Gray shapes within the section */}
      <div className="hidden lg:block absolute inset-0">
        <div className="absolute top-0 left-0 w-40 h-40 bg-gray-300 rounded-lg opacity-10"></div>
        <div className="absolute top-0 right-0 w-40 h-40 bg-gray-300 rounded-lg opacity-10"></div>
        <div className="absolute bottom-0 left-0 w-40 h-40 bg-gray-300 rounded-lg opacity-10"></div>
        <div className="absolute bottom-0 right-0 w-40 h-40 bg-gray-300 rounded-lg opacity-10"></div>
      </div>

      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        {/* Section title and subtitle */}
        <div className="mb-10 md:mb-16 text-center">
          <h2 className="text-4xl font-bold mb-4 md:text-5xl lg:text-6xl">{title}</h2>
          <p className="mx-auto max-w-screen-md text-lg md:text-xl">{subtitle}</p>
        </div>

        {/* Features grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8 lg:gap-16 mt-12">
          {features?.map((feature, index) => (
            <div
              key={index}
              className="flex items-center space-x-6 p-6 border border-alf rounded-lg hover:scale-105 hover:shadow-xl transition-all duration-300"
            >
              {/* Number inside a rounded square */}
              <div className="flex justify-center items-center  p-2 w-24 h-12 lg:w-48 lg:h-24 bg-alf rounded-lg text-black font-extrabold">
                <span className="text-xl lg:text-3xl">{index + 1}</span>
              </div>

              {/* Text beside the number */}
              <div>
                <h3
                  className="text-xl lg:text-2xl font-bold mb-2 text-alf"
                >
                  {feature.title}
                </h3>
                <p className="text-base lg:text-xl">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
